import React, { useState } from 'react'
import GoogleMapReact from 'google-map-react';

const K_CIRCLE_SIZE = 30;
const K_STICK_SIZE = 10;
const K_STICK_WIDTH = 3;

const greatPlaceStyle = {
    position: 'absolute',
    width: K_CIRCLE_SIZE,
    height: K_CIRCLE_SIZE + K_STICK_SIZE,
    left: -K_CIRCLE_SIZE / 2,
    top: -(K_CIRCLE_SIZE + K_STICK_SIZE),

};

const greatPlaceCircleStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: K_CIRCLE_SIZE,
    height: K_CIRCLE_SIZE,
    border: '3px solid #f44336',
    borderRadius: K_CIRCLE_SIZE,
    backgroundColor: '#f44336',
    textAlign: 'center',
    color: 'white',
    fontSize: 12,
    fontWeight: 'bold',
    padding: 0,
    cursor: 'pointer',
    boxShadow: '0 0 0 1px white'
};


const greatPlaceStickStyleShadow = {
    position: 'absolute',
    left: K_CIRCLE_SIZE / 2 - K_STICK_WIDTH / 2,
    top: K_CIRCLE_SIZE,
    width: K_STICK_WIDTH,
    height: K_STICK_SIZE,
    backgroundColor: '#f44336',
    boxShadow: '0 0 0 1px white'
};


const greatPlaceStickStyle = {
    position: 'absolute',
    left: K_CIRCLE_SIZE / 2 - K_STICK_WIDTH / 2,
    top: K_CIRCLE_SIZE,
    width: K_STICK_WIDTH,
    height: K_STICK_SIZE,
    backgroundColor: '#f44336'
};


const RenderizarComponente = ({ text }) => <div style={greatPlaceStyle}>
    <div style={greatPlaceStickStyleShadow} />
    <div style={greatPlaceCircleStyle}>
        {text}
    </div>
    <div style={greatPlaceStickStyle} />
</div>;

const Mapa = (props) => {
    const { zoomMapa = 15, latMapa = 5.342281, lngMapa = -72.397696, heightMapa = 100, widthMapa = 100 } = props?.styles

    return (
        <div style={{ height: `${heightMapa}vh`, width: `${widthMapa}%` }}>
            <GoogleMapReact
                bootstrapURLKeys={{ key: "AIzaSyDSPZc4rUlbyfLM4SLHe2c0iu8e-2TGGFA" }}
                center={{
                    lat: Number(latMapa),
                    lng: Number(lngMapa)
                }}
                zoom={zoomMapa}
            >
                <RenderizarComponente
                    lat={Number(latMapa)}
                    lng={Number(lngMapa)}
                    text=""
                />
            </GoogleMapReact>
        </div>
    )
}

export default Mapa